<template>
  <div
    v-for="column in columns"
    :key="column.name"
    class="ui-list__cell"
    :class="column.cellClass"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <slot
      :name="column.name"
      :item
      :hovered
    >
      {{
        column.formatter ? column.formatter(get(item, column.name)) : get(item, column.name)
      }}
    </slot>
  </div>
  <div
    v-if="!unremovable"
    class="ui-list__cell ui-list__cell--remove"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <UIButton
      :leading="TrashIcon"
      variant="danger"
      fill="light"
      size="sm"
      @click="handleRemove"
    />
  </div>
</template>

<script setup lang="ts">
import { get } from 'lodash'

import { ListColumn, ListItem } from './utils/types'

import { TrashIcon } from '@heroicons/vue/24/outline'
import { UIButton } from '@ui/buttons'

type Props = {
  columns: ListColumn[]
  item: ListItem
  unremovable?: boolean
  hovered?: boolean
}

type Emits = {
  remove: []
  mouseenter: []
  mouseleave: []
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleRemove = () => emit('remove')

const handleMouseEnter = () => {
  emit('mouseenter')
}

const handleMouseLeave = () => {
  emit('mouseleave')
}
</script>

<style>
.ui-list {
  &__cell {
    @apply py-2 px-1;
    @apply relative;
    @apply flex items-center;
    @apply text-sm sm:text-xs;

    @apply border-b border-common-border;

    &--remove {
      @apply px-0;
    }
  }
}
</style>
